export default class {

    constructor() {
		this.container = document.querySelector('.home-stats');

        if(this.container) {
			this.elements = document.querySelectorAll('.home-stats .stat');
			this.stats = document.querySelectorAll('.home-stats .stat .stat-number');

            this.started = null;
            this.interval = 20000;
            this.animationDuration = 2.5;

            this.fetch();
        }
    }

    /**
     * A cron is running on the server which fetches the required data from the
     * SeeingMachines private API. The cron writes a json file to /api/metrics.json
     * We grab this file and give the update the data-stat attribute by finding
     * The associated key in the json with data-stat-key
     */
    fetch() {
        $.getJSON('https://api.radar.orionair.com.au/owsa/v1', data => {

            for (let i = 0; i < this.stats.length; i++) {
                const element = this.stats[i];

                if(! element.dataset.statFrom) {
                    element.dataset.statFrom = 0;
                };

                element.dataset.statTo = data[element.dataset.statKey];
            }

            if(! this.started) {
                this.animateIn();
            }

            this.animate();
        });
    }

    /**
     * The initial animation revealing the tiles
     */
    animateIn() {
        for (let i = 0; i < this.elements.length; i++) {
            const element = this.elements[i];

            TweenMax.to(element, 2, {
                bottom: 0,
                opacity: 1,
                delay: i * .3,
            });
        }
    }

    /**
     * Increment the stats and animate the changes
     */
    animate() {
        for (let i = 0; i < this.stats.length; i++) {
            this.increment(this.stats[i]);
        }

        window.requestAnimationFrame(step => this.step(step));
    }

    /**
     *  Recursive RAF method, checks the interval and fetches new data
     */
    step(timestamp) {
        if (! this.started) this.started = timestamp;

        let progress = timestamp - this.started;

        if (progress >= this.interval) {
            this.started = timestamp;
            this.fetch();
        } else {
            window.requestAnimationFrame(step => this.step(step));
        }
    }

    /**
     * Animate the numbers from the previsouly loaded ajax call to the newest call
     */
    increment(element) {
        var stat = {
            current: parseInt(element.dataset.statFrom),
            target: parseInt(element.dataset.statTo - element.dataset.statFrom)
        }

        // Change the animation duration to a shorter time as we are incrementing smaller changes
        if(this.started) {
            this.animationDuration = .5;
        };

        TweenMax.to(stat, this.animationDuration, {current:`+=${stat.target}`, roundProps:"current", ease:Power1.easeOut, onUpdate: () => {
            element.innerHTML = stat.current.toLocaleString();
        }});

        // Set the from stat on the element for the next cycle
        element.dataset.statFrom = element.dataset.statTo;
    }
}